<!-- 会议论文集demo -->
<template>
  <div class="conferenceProceedings safe-distance-top-header">
    <Header pageTitle="会议论文集" />
    <div class="detail-box">
      <div class="baseinfo-box">
        <div class="logo-box">
          <img
            class="cover"
            :src="
              userInfo.cover
                ? $global.imgUrl + userInfo.cover
                : require('@/assets/img/mobile-img/image_error_ic.webp')
            "
            alt=""
          />
          <h2 class="name-box">{{ userInfo.name }}</h2>
        </div>
      </div>
      <div class="tabs-box">
        <van-tabs
          v-model="tabActive"
          class="tab-box"
          :ellipsis="false"
          color="#4a79f1"
          title-active-color="#4a79f1"
          title-inactive-color="#333"
          @change="tabsChange"
        >
          <van-tab title="基本信息" name="0">
            <div v-for="item in introLabelList" :key="item.key">
              <div class="tabs-info" v-if="item.value">
                <div class="info-lab">{{ item.label }}</div>
                <div class="info-content">
                  {{ item.value }}
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="会议论文集" name="1">
            <div class="conferencePaper">
              <van-list
                v-model="loading"
                :offset="0"
                :error="error"
                error-text="请求失败，点击重新加载"
                :finished="finished"
                :finished-text="articleList.length > 0 ? '加载完毕' : ''"
                :immediate-check="false"
                @load="onLoad"
              >
                <div class="lv-list" v-if="loading || articleList.length > 0">
                  <LvItem
                    class="lv-list-item"
                    v-for="item in articleList"
                    :key="item.articleId"
                    :title="item.title"
                    :artSummary="item.artSummary"
                    :author="item.author"
                    :periodicalName="item.mettingName"
                    :periodicalTime="item.mettingTime.slice(0, 10)"
                    @click.native="toDetail(item.articleId)"
                  />
                </div>
                <noneList class="no-list" noneType="lvList" v-else />
              </van-list>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/views/mobileView/components/header";
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  components: {
    Header,
    LvItem,
    noneList,
  },
  data() {
    return {
      userInfo: {
        name: "",
        cover: "",
      },
      tabActive: "0",
      introLabelList: [
        {
          label: "会议名称",
          key: "meetingName",
          value: "",
        },
        {
          label: "会议时间",
          key: "meetingDate",
          value: "",
        },
        {
          label: "会议地点",
          key: "meetingAddr",
          value: "",
        },
        {
          label: "主办单位",
          key: "orgs",
          value: "",
        },
        {
          label: "出版单位",
          key: "publisher",
          value: "",
        },
      ],

      params: {
        id: "",
        pageNo: 1,
        pageSize: 20,
      },
      total: 0,
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {
    this.params.id = this.$route.query.bid;
    this.getDetailInfo();
  },
  methods: {
    // 获取用户信息
    async getDetailInfo() {
      const res = await this.$apis.goodsServe.getCollectedDetail({
        bid: this.$route.query.bid,
      });
      if (res.resultCode === "200") {
        this.userInfo.cover = res.data.cover;
        this.userInfo.name = res.data.name;
        let detail = JSON.parse(res.data.detail);
        if (detail.meetingGoodsId && Object.keys(detail).length === 1) {
          const meetingDetailRes =
            await this.$apis.goodsServe.meetingDetailsByGoodsId({
              goodsId: detail.meetingGoodsId,
              frontEnd: 1,
            });
          if (meetingDetailRes.resultCode === "200") {
            detail.meetingName = meetingDetailRes.data.articleMeeting.title;
            detail.meetingDate =
              meetingDetailRes.data.articleMeeting.beginTime.slice(0, 10);
            detail.meetingAddr = `${meetingDetailRes.data.articleMeeting.province}${meetingDetailRes.data.articleMeeting.city}`;
            detail.orgs = meetingDetailRes.data.organizerList
              .map((item) => item.name)
              .join();
          }
        } else {
          detail.meetingDate = this.$global.transferDay(detail.meetingDate);
          detail.orgs = detail.orgs.map((item) => item.name).join();
          if (detail.meetingAddr) {
            const meetingAddr = detail.meetingAddr.split(",");
            const provinceRes = await this.$apis.userServe.proList();
            const cityRes = await this.$apis.userServe.cityList({
              provinceCode: meetingAddr[0],
            });
            if (
              provinceRes.resultCode === "200" &&
              cityRes.resultCode === "200"
            ) {
              meetingAddr[0] = provinceRes.content.provinceList.filter(
                (item) => item.code === meetingAddr[0]
              )[0].name;
              meetingAddr[1] = cityRes.content.cityList.filter(
                (item) => item.code === meetingAddr[1]
              )[0].name;
              detail.meetingAddr = meetingAddr.join("-");
            }
          }
        }
        this.introLabelList.forEach((item) => {
          item.value = detail[item.key];
        });
      } else {
      }
    },
    tabsChange(name) {
      if (name === "1") {
        if (this.params.pageNo === 1) {
          this.articleList = [];
          this.getList();
        }
      }
    },
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      const resp = await this.$apis.goodsServe.getMeetingDetailPaperList(
        this.params
      );
      if (resp.resultCode == 200) {
        this.articleList.push(...resp.data.list);
        this.finished = resp.data.list.length < 20;
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      let out = this.$route.query.out;
      if (out) {
        this.$router.push({
          name: "thesisDetail",
          query: {
            id,
            type: 0,
            out,
          },
        });
      } else {
        this.$router.push({
          name: "thesisDetail",
          query: {
            id,
            type: 0,
          },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.conferenceProceedings {
  min-height: 100vh;
  background-color: #f5f5f5;
  .detail-box {
    padding: 0 12px;
    .baseinfo-box {
      margin-bottom: 12px;
      padding: 16px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      .logo-box {
        display: flex;
        .cover {
          margin-right: 24px;
          width: 80px;
          height: 112px;
        }
        .name-box {
          flex: 1;
          margin-bottom: 23px;
          font-size: 16px;
          color: #333333;
          // line-height: 24px;
          word-break: break-all;
        }
      }
    }
    .tabs-box {
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      .tab-box {
        &::v-deep .van-tabs__wrap {
          .van-tabs__nav {
            padding-left: 0;
            padding-right: 0;
            .van-tab__text {
              font-size: 15px;
            }
            .van-tab--active {
              .van-tab__text {
                font-weight: 700;
              }
            }
          }
        }
        &::v-deep .van-tabs__content {
          padding: 16px;
        }
        .tabs-info {
          display: flex;
          margin-bottom: 15px;
          font-size: 14px;
          color: #333333;
          line-height: 24px;
          .info-lab {
            margin-right: 38px;
            width: 70px;
          }
          .info-content {
            flex: 1;
          }
        }
        .conferencePaper {
          //   margin: 20px 0;
          overflow: hidden;

          .lv-list {
            margin: 0px auto 0;
            background-color: #fff;
            border-radius: 8px;
            overflow: hidden;

            .lv-list-item {
              border-bottom: 1px solid #eee;
              &:last-child {
                border: none;
              }
            }
            .lv-item-box {
              &:first-child {
                margin-top: 0px;
              }
            }
          }
          .no-list {
            margin: 20px 0;
          }
        }
      }
    }
  }
}
</style>
